import { IRecommendedPackageSchema } from '../../../../repositories/billing-tariffs/v1/publish-terms';
import { EPackageType, IRecommendedPackage } from '../../../../types/reducers/recommendedPackages';
import { mapRecommendedPackageServices } from './mapRecommendedPackageServices';

export const mapRecommendedPackage = (recommendedPackage: IRecommendedPackageSchema): IRecommendedPackage => {
  const {
    id,
    type,
    headerText,
    tooltipText,
    durationInDays,
    regionNames,
    categoriesView,
    price,
    discountPercent,
    marketingPrice,
    announcementPrice,
    packageStartDate,
    packageEndDate,
    totalAnnouncementsCount,
    totalAuctionPointsCount,
    services,
    polygonIds,
  } = recommendedPackage;

  return {
    packageId: id,
    autoProlong: false,
    headerText,
    tooltipText,
    durationInDays,
    regionNames,
    categoriesView,
    price,
    discountPercent,
    marketingPrice,
    announcementPrice,
    packageStartDate,
    packageEndDate,
    totalAnnouncementsCount,
    totalAuctionPointsCount,
    selected: false,
    services: mapRecommendedPackageServices(services),
    type: type as string as EPackageType,
    polygonIds,
  };
};
